
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { products as localProducts } from "@/data/products";

export const useCategories = () => {
  return useQuery({
    queryKey: ["categories"],
    queryFn: async () => {
      try {
        const { data, error } = await (supabase as any)
          .from('categories')
          .select(`
            id,
            name,
            product_categories!inner (
              product_id,
              products!inner (
                id,
                published
              )
            )
          `)
          .eq('product_categories.products.published', true)
          .order('name', { ascending: true });

        if (error) throw error;

        const unique = new Set<string>();
        data.forEach((category: any) => {
          if (category.product_categories && category.product_categories.length > 0) {
            unique.add(category.name);
          }
        });

        let validCategories = Array.from(unique).sort();
        if (validCategories.length === 0) {
          validCategories = Array.from(
            new Set(localProducts.flatMap(p => p.categories))
          ).sort();
        }

        return validCategories;
      } catch (e) {
        return Array.from(new Set(localProducts.flatMap(p => p.categories))).sort();
      }
    },
    staleTime: 0, // Ne pas mettre en cache pour forcer le rafraîchissement
    refetchOnWindowFocus: true
  });
};
